import {networkResetDeviceConstants} from "../constants/network-reset-device.constants";
import {networkResetDeviceService} from "../services/network-reset-device.service";
import {history} from "../helpers/history";
import {toastr} from "react-redux-toastr";
import i18next from "i18next";

const getNetworkResetDeviceList = () => {
    return dispatch => {
        dispatch({type: networkResetDeviceConstants.NETWORK_RESET_DEVICE_LIST_REQUEST});
        networkResetDeviceService.getNetworkResetDeviceList()
            .then(
                (list) => {
                    dispatch({type: networkResetDeviceConstants.NETWORK_RESET_DEVICE_LIST_SUCCESS, list})
                },
                (error) => {
                    dispatch({type: networkResetDeviceConstants.NETWORK_RESET_DEVICE_LIST_FAILURE, error})
                }
            )
    }
}

const getNetworkResetDeviceById = (id) => {
    return dispatch => {
        dispatch({type: networkResetDeviceConstants.NETWORK_RESET_DEVICE_BY_ID_REQUEST});
        networkResetDeviceService.getNetworkResetDeviceById(id)
            .then(
                (item) => {
                    dispatch({type: networkResetDeviceConstants.NETWORK_RESET_DEVICE_BY_ID_SUCCESS, item})
                },
                (error) => {
                    dispatch({type: networkResetDeviceConstants.NETWORK_RESET_DEVICE_BY_ID_FAILURE, error})
                }
            )
    }
}

const createDevice = (resetDeviceModel) => {
    return dispatch => {
        networkResetDeviceService.createNetworkResetDevice(resetDeviceModel)
            .then(
                (res) => {
                    history.push('/panel/network-reset-device')
                    toastr.success(i18next.t('network-reset-device'), i18next.t('msg.create-done'));
                }
            )
    }
}

const editDevice = (resetDeviceModel) => {
    return dispatch => {
        networkResetDeviceService.editNetworkResetDevice(resetDeviceModel)
            .then(
                (res) => {
                    history.push('/panel/network-reset-device');
                    toastr.success(i18next.t('network-reset-device'), i18next.t('msg.update-done'));
                }
            )
    }
}

const removeDeviceById = (networkResetDeviceId) => {
    return dispatch => {
        networkResetDeviceService.removeNetworkResetDevice(networkResetDeviceId)
            .then(
                (res) => {
                    toastr.success(i18next.t('network-reset-device'), i18next.t('msg.remove-done'));
                }
            )
    }
}

const manualReset = (networkResetDeviceId) => {
    return dispatch => {
        networkResetDeviceService.manualReset(networkResetDeviceId)
            .then(
                () => { toastr.success(i18next.t('network-reset-device'), i18next.t('msg.reset-done')) },
            )
    }
}

const clearState = (networkResetDeviceId) => {
    return dispatch => {
        networkResetDeviceService.clearState(networkResetDeviceId)
            .then(
                () => { toastr.success(i18next.t('network-reset-device'), i18next.t('msg.clear-done')) },
            )
    }
}

export const networkResetDeviceActions = {
    getNetworkResetDeviceList,
    getNetworkResetDeviceById,
    createDevice,
    editDevice,
    removeDeviceById,
    manualReset,
    clearState,
}
